const modalOpenClass = 'product_swiper_modal_open';

window.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(modalOpenClass);
  if (!elements) {
    return;
  }
  if (window.matchMedia('(min-width:300px)').matches) {
    const slideLength = document.querySelectorAll(
      '#swiper_wrap .swiper-slide'
    ).length;
    let options = {};
    if (slideLength === 1) {
      options = {
        containerModifierClass: 'swiper_passive',
        allowTouchMove: false,
        loop: 'false',
        speed: 400,
        navigation: {
          nextEl: '.modal-swiper-button-next',
          prevEl: '.modal-swiper-button-prev',
        },
      };
    } else {
      options = {
        allowTouchMove: false,
        loop: 'true',
        speed: 400,
        navigation: {
          nextEl: '.modal-swiper-button-next',
          prevEl: '.modal-swiper-button-prev',
        },
      };
    }

    let projectSwiper = new Swiper('.modal_swiper', options);

    Array.from(elements).forEach((element) => {
      element.addEventListener('click', (event) => {
        console.log(element.id);
        projectSwiper.slideTo(element.id);

        event.preventDefault();
        $('#modal').addClass('open');
        $('body').addClass('hidden');
      });
    });
  }
});

if (window.matchMedia('(min-width:300px)').matches) {
  $('#modal_close, #modal_background').on('click', function (e) {
    $('#modal').removeClass('open');
    $('body').removeClass('hidden');
  });
}
